import { render, staticRenderFns } from "./raiseAQuestion.vue?vue&type=template&id=6ae5f2e0&scoped=true"
import script from "./raiseAQuestion.vue?vue&type=script&lang=js"
export * from "./raiseAQuestion.vue?vue&type=script&lang=js"
import style0 from "./raiseAQuestion.vue?vue&type=style&index=0&id=6ae5f2e0&prod&lang=less&scoped=true"
import style1 from "./raiseAQuestion.vue?vue&type=style&index=1&id=6ae5f2e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5f2e0",
  null
  
)

export default component.exports